import {
  Button,
  Card,
  Col,
  Row,
  message,
  Tabs,
  Input,
  Spin,
  Table,
  Modal,
  Form,
  Upload, Tooltip, Radio, type RadioChangeEvent, type TablePaginationConfig, Checkbox
} from 'antd'
import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import GoogleChartOrEmpty from '../common/GoogleChartOrEmpty'
import { useNavigate } from 'react-router-dom'
import '../../asserts/css/custom.css'
import InstitutionUserService from '../../services/InstitutionUserService'
import { isConnectivityFailure } from '../../utils/errorPopup'
import {
  generateChartRefundDataMFinance,
  generateChartBidSecurityDataMFinance
} from '../../utils/generateChartData'
import type { ColumnsType, SorterResult } from 'antd/es/table/interface'
import {
  UserOutlined,
  BankOutlined,
  IdcardOutlined,
  PayCircleOutlined,
  BuildOutlined,
  FileExcelOutlined,
  UploadOutlined,
  ZoomOutOutlined,
  TeamOutlined,
  UserAddOutlined,
  SafetyOutlined,
  ProfileOutlined,
  AuditOutlined,
  FileSearchOutlined,
  LinkOutlined,
  FileProtectOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons'
import { type UploadChangeParam } from 'antd/es/upload'
import TabPane from 'antd/es/tabs/TabPane'
import moment from 'moment/moment'
import { RefundAnalyticsDoughnut } from './RefundAnalyticsDoughnut'
import SupportStatsKpiCard from './SupportStatsKpiCard'
import PendingRefundBarChart, { type PendingRefundMonthRow } from './PendingRefundBarChart'

export const barOptions = {
  chart: {
    title: 'Bid Security Provided Per Month - All Years',
    subtitle: 'Amount Paid for Bid Security by Year and Month'
  },
  curveType: 'function',
  pointSize: 4,
  lineWidth: 2
}
export const barOptions2 = {
  chart: {
    title: 'Digital Refunded Amounts per Month',
    subtitle: 'Refunded Amount - 2023-Now'
  },
  curveType: 'function',
  pointSize: 4,
  lineWidth: 2
}

interface Role {
  id: string | number
  name: string
}

interface DataType {
  index: any
  key: React.Key
  bank_code: string
  transaction_reference: string
  debit_account_number: string
  debit_account_name: string
  beneficiary_account_name: string
  beneficiary_bank_name: string
  beneficiary_account_number: string
  transaction_currency: string
  amount: number
  reason: string
  status: string
  created_at: string
  updated_at: string
  totalPayments: string
  amountRequestedToBeRefund: string
  amountRequestedToBeRefundedInProgressStatus: string
  TotalNumberOfApplicantRequestedRefund: string
  notRequestedBidders: string
  UserRoles: string
}

const FullDashboardView: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [stats, setStats] = React.useState<Record<string, any>>({})
  const [statsRefund, setStatsRefund] = React.useState<Record<string, any>>({})
  const [statsBailiffRefund, setStatsBailiffRefund] = React.useState<Record<string, any>>({})
  const [pendingRefundByMonth, setPendingRefundByMonth] = React.useState<PendingRefundMonthRow[]>(
    []
  )
  const [totalPaid, setTotalPaidAmount] = useState(0)
  const [certifiedCheckAmount, setCertifiedCheckAmount] = useState(0)
  const [bidGuaranteeAmount, setBidGuaranteeAmount] = useState(0)
  const [digitalPaymentAmount, setDigitalPaymentAmount] = useState(0)
  const [currentTime, setCurrentTime] = useState(new Date())
  const [activeTab, setActiveTab] = useState('bidders') // Default tab
  const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([])
  const [refundRequestList, setRefundRequestList] = useState<DataType[]>([])
  const [totalAmount, setTotalAmount] = useState(0)
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })
  const [userAccountsList, setUserAccountsList] = useState([])
  const [paginating, setPaginating] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    total: 0
  })

  const [filterStatus, setfilterStatus] = useState('')
  const [RolesDescription, setRoleDescription] = useState('')
  const [UsersRoles, setUserRoles] = useState('')
  const [userRolesView, setUserRolesView] = useState<Role[]>([])
  const [selectedRole, setSelectedRole] = useState('')
  const [responseData, setResponseData] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [loading, setLoading] = useState(false)
  const [clear, setClear] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isSettingModalVisible, setIsSettingModalVisible] = useState(false)
  const [fileName, setFileName] = useState<string | null>(null)
  const [isUploadActive, setIsUploadActive] = useState(false)
  const [activeForm, setActiveForm] = useState<string | null>('viewAllUsers')
  const [auditLogs, setAuditLogs] = useState<any[]>([])
  const [auditLogsPagination, setAuditLogsPagination] = useState({ current: 1, pageSize: 20, total: 0 })
  const [loadingAuditLogs, setLoadingAuditLogs] = useState(false)
  const onUserTypeChange = (value: string): null => {
    return null
  }
  const { Option } = Select
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleRadioChange = (e: RadioChangeEvent) => {
    setIsUploadActive(e.target.value === 'upload') // Set upload state based on radio button value
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const showModal = () => {
    setIsModalVisible(true)
  }

  const permissions = [
    'Read Access',
    'Write Access',
    'Admin Access',
    'Manage Settings',
    'View Reports',
    'Export Data'
  ]

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const showSettingsModal = () => {
    setIsSettingModalVisible(true)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCancel = () => {
    setIsModalVisible(false)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSettingsCancel = () => {
    setIsSettingModalVisible(false)
    setActiveForm('viewAllUsers') // Reset to default view
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOk = () => {
    navigate('/create-bank-details') // Navigate to the bank details creation page
    setIsModalVisible(false) // Close modal after navigation
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const customRequest = ({ file, onSuccess, onError }: any) => {
    // Mock upload function, you can implement real file upload logic
    setTimeout(() => {
      onSuccess('ok')
    }, 1000)
  }

  // Handle file upload change (for Excel file)
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFileUpload = (info: UploadChangeParam) => {
    if (info.file.status === 'done') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.success(`${info.file.name} file uploaded successfully.`)
    } else if (info.file.status === 'error') {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.error(`${info.file.name} file upload failed.`)
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFormToggle = (formType: string) => {
    // If the clicked button matches the active form, toggle it off
    // Otherwise, set the new form as active (and close any other open forms)
    if (activeForm === formType) {
      setActiveForm(null)
    } else {
      setActiveForm(formType)
    }
  }

  React.useEffect(() => {
    InstitutionUserService.SAdminStats()
      .then((res: any) => {
        const chartData = generateChartBidSecurityDataMFinance(
          res?.data?.bidSecurityBarData ?? []
        )
        setStats((prev) => ({
          ...prev,
          ...res?.data,
          chart: chartData
        }))
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  React.useEffect(() => {
    InstitutionUserService.MFinanceRefundStats()
      .then((res: any) => {
        const chartRefundData = generateChartRefundDataMFinance(res?.data.barData)

        setStats((prev) => ({
          ...prev,
          ...res?.data,
          chartRefundData
        }))
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  // Fetch refund stats for pie chart
  React.useEffect(() => {
    InstitutionUserService.RefundRequestStats()
      .then((res: any) => {
        setStatsRefund(res.data)
      })
      .catch((err) => {
        void message.error(err?.message)
      })

    InstitutionUserService.bailiffRefundRequestStats()
      .then((response: any) => {
        setStatsBailiffRefund(response.data)
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  React.useEffect(() => {
    InstitutionUserService.GetPendingRefundRequestsByMonth(12)
      .then((res: any) => {
        if (res?.status === 200 && Array.isArray(res.data?.months)) {
          setPendingRefundByMonth(res.data.months as PendingRefundMonthRow[])
        } else {
          setPendingRefundByMonth([])
        }
      })
      .catch(() => {
        setPendingRefundByMonth([])
      })
  }, [])

  // Fetch MFinance stats for total paid calculation
  useEffect(() => {
    InstitutionUserService.MFinanceStats()
      .then((res: any) => {
        const certifiedCheckAmt = parseInt(res?.data?.certified_checks)
        const bidGuaranteeAmt = parseInt(res?.data?.bid_guarantees)
        const digitalPaymentAmt = parseInt(res?.data?.payments?.totalPayments)

        setCertifiedCheckAmount(isNaN(certifiedCheckAmt) ? 0 : certifiedCheckAmt)
        setBidGuaranteeAmount(isNaN(bidGuaranteeAmt) ? 0 : bidGuaranteeAmt)
        setDigitalPaymentAmount(isNaN(digitalPaymentAmt) ? 0 : digitalPaymentAmt)
      })
      .catch((err) => {
        void message.error(err?.message)
      })
  }, [])

  // Calculate total paid amount
  useEffect(() => {
    const totalPaidAmount = certifiedCheckAmount + bidGuaranteeAmount + digitalPaymentAmount
    setTotalPaidAmount(totalPaidAmount)
  }, [certifiedCheckAmount, bidGuaranteeAmount, digitalPaymentAmount])

  const clearFilter = (): void => {
    setfilterStatus('')
    setFromDate('')
    setToDate('')
    setClear(true)
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/no-shadow
  const handleTableChange = (pagination: any) => {
    setPagination(pagination) // Update pagination state on page change
  }

  useEffect(() => {
    if (activeTab === 'bidders') {
      const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0)
      setTotalAmount(total)
    } else if (activeTab === 'bailiffs') {
      const total = bailiffRefundRequestList.reduce((acc, curr) => acc + curr.amount, 0)
      setTotalAmount(total)
    }
  }, [refundRequestList, bailiffRefundRequestList, activeTab])

  // UseEffect for fetching refund request data when needed
  useEffect(() => {
    OnRefundRequestSearch()
  }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate])

  const OnRefundRequestSearch = (event?: any): void => {
    setLoading(true)

    const service = activeTab === 'bidders'
      ? InstitutionUserService.GetPendingRefundRequestListByStatusFromBidders
      : InstitutionUserService.GetPendingRefundRequestListByStatusFromBailiffs

    service(
      pagination.pageSize,
      pagination.current,
      event?.target?.value,
      fromDate,
      toDate
    )
      .then((res: any) => {
        setLoading(false)

        if (res.status === 200) {
          const data = res?.data
          if (data === null || data === undefined || data.length === 0) {
            if (activeTab === 'bidders') {
              setRefundRequestList([])
              void message.info('No New Refund Request found')
            } else if (activeTab === 'bailiffs') {
              setBailiffRefundRequestList([])
              void message.info('No New Refund Request found')
            }
          } else {
            if (activeTab === 'bidders') {
              setRefundRequestList(data)
            } else if (activeTab === 'bailiffs') {
              setBailiffRefundRequestList(data)
            }
            setPagination((prev) => ({
              ...prev,
              total: res?.meta?.total
            }))
          }
        } else if (res.status === 404) {
          if (activeTab === 'bidders') {
            void message.info('No New refund request found')
            setRefundRequestList([])
          } else if (activeTab === 'bailiffs') {
            void message.info('No New refund request found')
            setBailiffRefundRequestList([])
          }
        }
      })
      .catch((err: any) => {
        setLoading(false)
        if (err?.message === 'Operation canceled due to new request.') {
          return
        }
        if (!isConnectivityFailure(err)) {
          void message.error(err?.message)
        }
        if (activeTab === 'bidders') {
          setRefundRequestList([])
        } else {
          setBailiffRefundRequestList([])
        }
        setPagination((prev) => ({
          ...prev,
          total: 0
        }))
      })
  }

  const onRolesView = (event?: any): void => {
    setLoading(true)
    InstitutionUserService.getUserRoles()
      .then((res: any) => {
        if (res.status === 200) {
          setUserRolesView(res?.data)

          setPaginating((prev) => ({
            ...prev,
            total: res?.meta?.total
          }))
          setLoading(false)
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          void message.error(err?.message)
        }
        setLoading(false)
      })
  }

  useEffect(() => {
    onRolesView()
  }, [])

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleChange = (value: string) => {
    setSelectedRole(value)
  }

  // Format date
  const formatDate = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }
    return date.toLocaleDateString(undefined, options)
  }

  // Format time
  const formatTime = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }
    return date.toLocaleTimeString(undefined, options)
  }

  const bailiffsColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        const pageNumber = (pagination.current !== 0) || 1
        const pageSize = (pagination.pageSize !== 0) || 10
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false
    },
    {
      title: 'Ref.No',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      width: 100,
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      width: 100,
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      render: (text: string) => {
        return text
          .toLowerCase() // Convert all text to lowercase
          .replace(/\b\w/g, (char) => char.toUpperCase())
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(record?.amount, 10)
        return amount.toLocaleString()
      },
      sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true
    }
  ]

  const biddersColumns: ColumnsType<DataType> = [
    {
      title: 'No.',
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text, record, index) => {
        const pageNumber = (pagination.current !== 0) || 1
        const pageSize = (pagination.pageSize !== 0) || 10
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
        return <span>{globalIndex}</span>
      },
      sorter: (a, b) => a.index - b.index,
      sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
      ellipsis: false
    },
    {
      title: 'Ref. No',
      dataIndex: 'transaction_reference',
      key: 'transaction_reference',
      width: 100,
      sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
      sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'beneficiary_account_name',
      key: 'beneficiary_account_name',
      width: 120,
      sorter: (a: any, b: any) => a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
      sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
      render: (text: string) => {
        return text
          .toLowerCase() // Convert all text to lowercase
          .replace(/\b\w/g, (char) => char.toUpperCase())
      }

    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (_text: any, record: any) => {
        const amount = parseInt(record?.amount, 10)
        return amount.toLocaleString()
      },
      sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
      sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
      ellipsis: true
    }
  ]

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  interface ApiError {
    response?: {
      data: {
        message?: string
      }
    }
  }

  function isApiError(error: unknown): error is ApiError {
    return (
      typeof error === 'object' && error !== null &&
      'response' in error &&
      (error as ApiError).response?.data?.message !== undefined
    )
  }

  const onUserCreate = (values: any): void => {
    setLoading(true)
    InstitutionUserService.CreateUsersAccount(values)
      .then((res: any) => {
        setLoading(false)
        void message.success(res.message)
        navigate('/users-accounts-list')
      })
      .catch((err: any) => {
        setLoading(false)
        void message.error(err?.response?.data?.message)
      })
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onFinish = async (values: any) => {
    setLoading(true)

    try {
      // Extract role name, description, and selected permissions from the form values
      const roleName = values.role // Value from the 'role' select field
      const roleDescription = values.description // Value from the 'description' textarea
      const selectedPermissions = values.permissions // Selected permissions from checkbox group

      // Set the role name and description states
      setUserRoles(roleName)
      setRoleDescription(roleDescription)

      // Logging for debugging or tracking purposes
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Role: ${roleName}`)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Description: ${roleDescription}`)
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      void message.info(`Permissions: ${selectedPermissions.join(', ')}`)

      // Define permissionsRoles by generating permission-role associations
      const permissionsRoles = selectedPermissions.map((permission: any, index: number) => ({
        permissionId: `permission-id-${index + 1}`, // These IDs would need to come from the actual backend response
        roleId: `role-id-${index + 1}` // This is a placeholder for now; make sure this is correctly mapped from the backend
      }))

      try {
        void message.info(`Permissions Roles: ${JSON.stringify(permissionsRoles, null, 2)}`)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error stringifying permissionsRoles:', error)
      }

      // The body to send in the API request, matching the payload structure
      const body = {
        roleName, // The name of the role
        roleDescription, // The description of the role
        permissions: selectedPermissions.map((permission: any) => ({ name: permission })), // Send permissions in the required format (array of objects with 'name' key)
        permissionsRoles // Send permissionsRoles as an array of permission-role associations
      }

      // Call the CreateRolesAndPermissions service to submit the data
      const response = await InstitutionUserService.CreateRolesAndPermissions(body)
      setResponseData(response)

      // Check the response status and display the message
      if (response.status === 200) {
        // Success case: Display success message and reset the form
        void message.success(response.message) // Display the success message from backend
        form.resetFields()
        navigate('/dashboard') // Redirect to the user accounts page or relevant page
      } else {
        // Handle other cases (e.g., 400, 401, etc.)
        void message.error((Boolean(response.message)) || 'Failed to create role and permissions. Please try again.')
      }
    } catch (error) {
      // Log the error to the console for debugging
      // eslint-disable-next-line no-console
      console.error('Error creating roles and permissions:', error)

      // Use the type guard to check if the error is an ApiError
      if (isApiError(error)) {
        const errorMessage = ((error.response?.data?.message) != null) || 'An error occurred. Please try again.'
        void message.error(errorMessage)
      } else {
        void message.error('An error occurred. Please try again.')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    OnUserAccountsSearch()
    // eslint-disable-next-line
  }, [clear, paginating.current, paginating.pageSize])

  const OnUserAccountsSearch = (event?: any): void => {
    setLoading(true)
    InstitutionUserService.getUserAccountsList(
      paginating.pageSize as number,
      paginating.current as number,
      event?.target?.value,
      filterStatus,
      fromDate,
      toDate
    )
      .then((res: any) => {
        if (res.status === 200) {
          setUserAccountsList(res?.data)
          setPaginating((prev) => ({
            ...prev,
            total: res?.meta?.total
          }))
          setLoading(false)
        }
      })
      .catch((err: any) => {
        if (err?.message !== 'Operation canceled due to new request.') {
          void message.error(err?.message)
        }
        setLoading(false)
      })
  }

  const columnsViewMode: ColumnsType<DataType> = [
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📅 Date Added</span>,
      dataIndex: 'created_at',
      key: 'created_at',
      width: 130,
      render: (text: any, record: any) => (
        <span style={{
          fontSize: '14px',
          color: '#6b7280',
          fontWeight: '500'
        }}>
          {moment(record.created_at).format('MMM DD, YYYY')}
        </span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>👤 Full Name</span>,
      dataIndex: 'full_name',
      key: 'full_name',
      width: 180,
      render: (text: any) => (
        <span style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#1f2937'
        }}>
          {text}
        </span>
      ),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>🆔 National ID</span>,
      dataIndex: 'nid',
      key: 'nid',
      width: 160,
      render: (text: any) => (
        <span style={{
          fontSize: '13px',
          color: '#4b5563',
          fontFamily: 'monospace',
          background: '#f3f4f6',
          padding: '4px 8px',
          borderRadius: '6px'
        }}>
          {text}
        </span>
      ),
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📱 Phone</span>,
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 130,
      render: (text: any) => (
        <span style={{
          fontSize: '14px',
          color: '#37762f',
          fontWeight: '500'
        }}>
          {text}
        </span>
      ),
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📧 Email</span>,
      dataIndex: 'email',
      key: 'email',
      width: 200,
      render: (text: any) => (
        <span style={{
          fontSize: '13px',
          color: '#37762f',
          fontWeight: '500'
        }}>
          {text}
        </span>
      ),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>🎭 Role</span>,
      dataIndex: 'role',
      key: 'role',
      width: 180,
      render: (text: any) => {
        const roleColors: any = {
          'SYSTEM ADMIN': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'SUPER USER': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'INSTITUTION ADMIN': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'INSTITUTION USER': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'MINIJUST FINANCE': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'SYSTEM SUPPORT': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' }
        }
        const style = roleColors[text ?? ''] ?? { bg: '#f3f4f6', color: '#374151', border: '#d1d5db' }
        return (
          <span style={{
            fontSize: '12px',
            fontWeight: '600',
            background: style.bg,
            color: style.color,
            padding: '4px 12px',
            borderRadius: '12px',
            border: `1px solid ${String(style.border)}`,
            display: 'inline-block',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            {text}
          </span>
        )
      },
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📊 Status</span>,
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (text: any) => {
        const isActive = text?.toUpperCase() === 'ACTIVE'
        return (
          <span style={{
            fontSize: '12px',
            fontWeight: '700',
            background: isActive ? '#f0fdf4' : '#fee2e2',
            color: isActive ? '#37762f' : '#991b1b',
            padding: '5px 14px',
            borderRadius: '14px',
            border: `2px solid ${isActive ? '#37762f' : '#f87171'}`,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            <span style={{ fontSize: '8px' }}>{isActive ? '●' : '●'}</span>
            {text}
          </span>
        )
      },
      ellipsis: true
    }
  ]

  const columns: ColumnsType<DataType> = [
    {
      title: 'Date Added',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any, record: any) => (
        <span>{moment(record.created_at).format('YYYY-MM-DD')}</span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'Names',
      dataIndex: 'full_name',
      key: 'full_name',
      // sorter: (a, b) => a.full_name.localeCompare(b.full_name),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'ID Number',
      dataIndex: 'nid',
      key: 'nid',
      ellipsis: true
    },
    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      ellipsis: true
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      // sorter: (a, b) => a.email.localeCompare(b.email),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: 'User Type',
      dataIndex: 'role',
      key: 'role',
      ellipsis: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      ellipsis: true
    },
    {
      title: 'Action',
      dataIndex: 'action',
      render: (text: any, record: any) => (
        <div className="flex icon-container">
          <i
            className="far fa-eye cursor-pointer icon-style"
            onClick={() => {
              navigate('/view-user-account', { state: record })
            }}
          ></i>
        </div>
      )
    }
  ]

  const columnsEditRolesAndUserStatus: ColumnsType<DataType> = [
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📅 Date Added</span>,
      dataIndex: 'created_at',
      key: 'created_at',
      width: 130,
      render: (text: any, record: any) => (
        <span style={{
          fontSize: '14px',
          color: '#6b7280',
          fontWeight: '500'
        }}>
          {moment(record.created_at).format('MMM DD, YYYY')}
        </span>
      ),
      sorter: (a: any, b: any) => moment(a.created_at).unix() - moment(b.created_at).unix(),
      sortOrder: sortedInfo.columnKey === 'created_at' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>👤 Full Name</span>,
      dataIndex: 'full_name',
      key: 'full_name',
      width: 180,
      render: (text: any) => (
        <span style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#1f2937'
        }}>
          {text}
        </span>
      ),
      sortOrder: sortedInfo.columnKey === 'full_name' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>🆔 National ID</span>,
      dataIndex: 'nid',
      key: 'nid',
      width: 160,
      render: (text: any) => (
        <span style={{
          fontSize: '13px',
          color: '#4b5563',
          fontFamily: 'monospace',
          background: '#f3f4f6',
          padding: '4px 8px',
          borderRadius: '6px'
        }}>
          {text}
        </span>
      ),
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📱 Phone</span>,
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 130,
      render: (text: any) => (
        <span style={{
          fontSize: '14px',
          color: '#37762f',
          fontWeight: '500'
        }}>
          {text}
        </span>
      ),
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📧 Email</span>,
      dataIndex: 'email',
      key: 'email',
      width: 200,
      render: (text: any) => (
        <span style={{
          fontSize: '13px',
          color: '#37762f',
          fontWeight: '500'
        }}>
          {text}
        </span>
      ),
      sortOrder: sortedInfo.columnKey === 'email' ? sortedInfo.order : null,
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>🎭 Role</span>,
      dataIndex: 'role',
      key: 'role',
      width: 180,
      render: (text: any) => {
        const roleColors: any = {
          'SYSTEM ADMIN': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'SUPER USER': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'INSTITUTION ADMIN': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'INSTITUTION USER': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'MINIJUST FINANCE': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' },
          'SYSTEM SUPPORT': { bg: '#f0fdf4', color: '#37762f', border: '#37762f' }
        }
        const style = roleColors[text ?? ''] ?? { bg: '#f3f4f6', color: '#374151', border: '#d1d5db' }
        return (
          <span style={{
            fontSize: '12px',
            fontWeight: '600',
            background: style.bg,
            color: style.color,
            padding: '4px 12px',
            borderRadius: '12px',
            border: `1px solid ${String(style.border)}`,
            display: 'inline-block',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            {text}
          </span>
        )
      },
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>📊 Status</span>,
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (text: any) => {
        const isActive = text?.toUpperCase() === 'ACTIVE'
        return (
          <span style={{
            fontSize: '12px',
            fontWeight: '700',
            background: isActive ? '#f0fdf4' : '#fee2e2',
            color: isActive ? '#37762f' : '#991b1b',
            padding: '5px 14px',
            borderRadius: '14px',
            border: `2px solid ${isActive ? '#37762f' : '#f87171'}`,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            <span style={{ fontSize: '8px' }}>{isActive ? '●' : '●'}</span>
            {text}
          </span>
        )
      },
      ellipsis: true
    },
    {
      title: <span style={{ fontWeight: '600', color: '#37762f' }}>👁️ Action</span>,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      align: 'center',
      render: (text: any, record: any) => (
        <Button
          type="primary"
          shape="circle"
          icon={<i className="far fa-eye" style={{ fontSize: '16px' }}></i>}
          size="large"
            onClick={() => {
              navigate('/view-user-account', { state: record })
            }}
          style={{
            background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
            border: 'none',
            boxShadow: '0 2px 8px rgba(55, 118, 47, 0.3)',
            transition: 'all 0.3s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(55, 118, 47, 0.5)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)'
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(55, 118, 47, 0.3)'
          }}
        />
      )
    }
  ]
  const data = userAccountsList

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const generateCalendar = () => {
    const year = currentTime.getFullYear()
    const month = currentTime.getMonth()
    const today = currentTime.getDate()

    // Day names
    const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

    // Month name
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]

    // Create calendar grid
    const calendarDays = []

    // Add day headers
    dayNames.forEach(day => {
      calendarDays.push(
        <div key={`header-${day}`} className="text-center text-xs font-medium py-1">
          {day}
        </div>
      )
    })

    // Get the current day of week (0-6)
    const currentDayOfWeek = new Date(year, month, today).getDay()

    // Calculate start date (go back to find Sunday of the week before)
    // This ensures we show the current week plus one week before and one after
    const startDay = today - currentDayOfWeek - 7

    // We'll show 3 weeks (21 days) centered around current week
    for (let i = 0; i < 21; i++) {
      const displayDay = startDay + i
      const displayDate = new Date(year, month, displayDay)
      const dayOfMonth = displayDate.getDate()
      const isCurrentMonth = displayDate.getMonth() === month
      const isToday = isCurrentMonth && dayOfMonth === today

      calendarDays.push(
        <div
          key={`day-${i}`}
          className={`text-center py-1 text-sm ${
            isToday
              ? 'bg-blue-500 text-white rounded-full font-bold'
              : isCurrentMonth
                ? ''
                : 'text-gray-300'
          }`}
        >
          {dayOfMonth}
        </div>
      )
    }

    return (
      <div className="mt-2">
        <div className="text-center font-medium mb-2">
          {monthNames[month]} {year}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {calendarDays}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full p-body">
      <style>{`
        .stats-card {
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .stats-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
        }
        .chart-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .chart-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-button {
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .enhanced-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      `}</style>

      {/* Enhanced Header Section - Matching FinanceDashboard */}
      <div className="px-5 py-4 border-b-slate-200 border border-solid w-full" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px'
      }}>
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:justify-between lg:items-start">
          <div className="text-base font-bold w-full lg:w-2/3">
            <div className="flex items-center justify-center lg:justify-start mb-4">
              <div style={{
                background: 'var(--refund-theme-primary-soft)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }}>
                <span style={{ fontSize: '24px' }}>📊</span>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <h2 className="text-title font-bold" style={{
                  margin: 0,
                  color: '#111827'
                }}>
                  Full Dashboard
                </h2>
                <p style={{
                  margin: '4px 0 0 0',
                  fontSize: '14px',
                  color: '#6b7280',
                  fontWeight: '500'
                }}>
                  📈 Complete Overview • Analytics Dashboard
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-2 sm:p-4 md:p-6">
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={16} xl={16} order={1}>
            <Row gutter={[8, 8]} style={{ width: '100%' }} className="mb-4">
              <Col xs={24} sm={12} md={8} xl={8} className="mb-4">
                <SupportStatsKpiCard
                  title="Added Institutions"
                  category="Total count"
                  value={stats?.institutions ?? 0}
                  accent="#4338ca"
                  icon={<BankOutlined />}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={8} className="mb-4">
                <SupportStatsKpiCard
                  title="Provided"
                  category="Bid guarantees"
                  value={stats?.bid_guarantees ?? 0}
                  accent="#37762f"
                  icon={<FileProtectOutlined />}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={8} className="mb-4">
                <SupportStatsKpiCard
                  title="Provided"
                  category="Certified checks"
                  value={stats?.certified_checks ?? 0}
                  accent="#0f766e"
                  icon={<SafetyCertificateOutlined />}
                />
              </Col>
            </Row>

            <Row gutter={[8, 8]} className="mt-2 mb-6">
              <Col xs={24} className="mb-4">
                <Card
                  className="chart-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center overflow-auto" style={{ maxWidth: '100vw' }}>
                    <div style={{
                      background: 'var(--refund-theme-primary-soft)',
                      color: '#111827',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '20px'
                    }}>
                      📊 Bid Security Provided Per Month
                    </div>
                    <GoogleChartOrEmpty
                      chartType="Line"
                      width="100%"
                      height="400px"
                      data={stats?.chart}
                      options={{
                        ...barOptions,
                        responsive: true,
                        maintainAspectRatio: false,
                        backgroundColor: 'transparent',
                        chartArea: {
                          backgroundColor: 'transparent'
                        }
                      }}
                    />
                  </div>
                </Card>
              </Col>
            </Row>
            <Row gutter={[8, 8]} style={{ marginTop: 16 }}>
              <Col xs={24} className="mb-4">
                <Card
                  className="chart-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center overflow-auto" style={{ maxWidth: '100vw' }}>
                    <div style={{
                      background: 'var(--refund-theme-primary-soft)',
                      color: '#111827',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '20px'
                    }}>
                      📈 Digital Refunded Amounts per Month
                    </div>
                    <GoogleChartOrEmpty
                      chartType="Line"
                      width="100%"
                      height="300px"
                      data={stats?.chartRefundData}
                      options={{
                        ...barOptions2,
                        responsive: true,
                        maintainAspectRatio: false,
                        backgroundColor: 'transparent',
                        chartArea: {
                          backgroundColor: 'transparent'
                        }
                      }}
                    />
                    <PendingRefundBarChart rows={pendingRefundByMonth} chartHeight={260} />
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={24} md={8} xl={8} order={2}>
            <Row gutter={[8, 8]} className="h-full mb-6">
              <Col xs={24} md={24} xl={24} className="mb-4">
                <Card
                  className="enhanced-card h-full"
                  style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <div className="text-center py-4 rounded-t-lg flex items-center justify-center" style={{
                    background: 'var(--refund-theme-primary-soft)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    marginBottom: '16px',
                    borderRadius: '8px'
                  }}>
                    <div style={{
                      background: '#ffffff',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid var(--refund-theme-border)',
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '12px'
                    }}>
                      <i className="fas fa-tasks text-2xl" style={{ color: '#111827' }}></i>
                    </div>
                    <div className="text-xl font-bold" style={{
                      color: '#111827',
                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>Quick Actions</div>
                  </div>

                  {/* Add an institution Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/create-institution') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-building mr-4 text-white text-xl"></i>
                      <span className="text-md">Add an institution</span>
                    </Button>
                  </div>

                  {/* View all institutions Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/institutions-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-list mr-4 text-white text-xl"></i>
                      <span className="text-md">View all institutions</span>
                    </Button>
                  </div>

                  {/* View all bid security provided Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/bid-guarantee-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-shield-alt mr-4 text-white text-xl"></i>
                      <span className="text-md">View all bid security provided</span>
                    </Button>
                  </div>

                  {/* View all bid security payments Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/payment-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-money-check-alt mr-4 text-white text-xl"></i>
                      <span className="text-md">View all bid security payments</span>
                    </Button>
                  </div>
                  <div className="p-2.5">
                    <Button
                      onClick={() => { navigate('/bidder-list') }}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-user-edit mr-4 text-white text-xl"></i>
                      <span className="text-md">Update bidder information</span>
                    </Button>
                  </div>
                  {/* Add Bank details Button */}
                  <div className="p-2.5">
                    <Button
                      onClick={showModal}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-university mr-4 text-white text-xl"></i>
                      <span className="text-md">Add Bank Details</span>
                    </Button>
                    <Modal
                      title="Add Bank Details"
                      visible={isModalVisible}
                      onOk={handleOk}
                      onCancel={handleCancel}
                      okText="Proceed"
                      cancelText="Cancel"
                      width={600}
                      className="custom-modal"
                    >
                      <Tabs defaultActiveKey="1">
                        {/* Tab 1 - Bank Details Form */}
                        <Tabs.TabPane tab={<span><BankOutlined /> Institution Bank Details</span>} key="1">
                          {/* Form inside the Modal */}
                          <Form form={form} layout="vertical" name="addBankDetailsForm">
                            <Form.Item
                              label="Bank Name"
                              name="bankName"
                              rules={[{ required: true, message: 'Please enter the bank name!' }]}
                            >
                              <Input
                                prefix={<BankOutlined className="text-xl text-blue-500" />}
                                placeholder="Enter Bank Name"
                              />
                            </Form.Item>

                            <Form.Item
                              label="Account Name"
                              name="accountName"
                              rules={[{ required: true, message: 'Please enter the account name!' }]}
                            >
                              <Input
                                prefix={<UserOutlined className="text-xl text-blue-500" />}
                                placeholder="Enter Account Name"
                              />
                            </Form.Item>

                            <Form.Item
                              label="Account Number"
                              name="accountNumber"
                              rules={[{ required: true, message: 'Please enter the account number!' }]}
                            >
                              <Input
                                prefix={<IdcardOutlined className="text-xl text-blue-500" />}
                                placeholder="Enter Account Number"
                              />
                            </Form.Item>

                            <Form.Item
                              label="Used For"
                              name="accountType"
                              rules={[{ required: true, message: 'Please select the account type!' }]}
                            >
                              <Select placeholder="Select Account Type">
                                <Select.Option value="cyamunara" key="cyamunara">
                                  <PayCircleOutlined className="mr-2 text-blue-500" />
                                  Cyamunara
                                </Select.Option>
                                <Select.Option value="publicTreasury" key="publicTreasury">
                                  <BuildOutlined className="mr-2 text-blue-500" />
                                  Public Treasury Accounts
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Form>
                        </Tabs.TabPane>

                        {/* Tab 2 - Upload Excel File */}
                        <Tabs.TabPane tab={<span><FileExcelOutlined /> Add Banks Information</span>} key="2">
                          {/* Form for Bank Details with Status */}
                          <Form form={form} layout="vertical" name="addBankDetailsForm">
                            <Form.Item
                              label="Bank Name"
                              name="bankName"
                              rules={[{ required: true, message: 'Please enter the bank name!' }]}
                            >
                              <Input
                                prefix={<BankOutlined className="text-xl text-blue-500" />}
                                placeholder="Enter Bank Name"
                              />
                            </Form.Item>

                            <Form.Item
                              label="Bank Code"
                              name="bankCode"
                              rules={[{ required: true, message: 'Please enter the bank code!' }]}
                            >
                              <Input
                                prefix={<UserOutlined className="text-xl text-blue-500" />}
                                placeholder="Enter Bank Code"
                              />
                            </Form.Item>

                            <Form.Item
                              label="Status"
                              name="status"
                              rules={[{ required: true, message: 'Please select the status!' }]}
                            >
                              <Select placeholder="Select Status">
                                <Select.Option value="active" key="active">
                                  Active
                                </Select.Option>
                                <Select.Option value="inactive" key="inactive">
                                  Inactive
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Form>
                          <div>
                            {/* Radio buttons to toggle upload */}
                            <Radio.Group onChange={handleRadioChange} defaultValue="">
                              <Radio value="upload">Upload Bank Information</Radio>
                              <Radio value="skip">Skip File Upload</Radio>
                            </Radio.Group>

                            {/* Conditional rendering based on the radio button selection */}
                            {isUploadActive && (
                              <div>
                                <p className="mt-2" style={{ marginTop: '16px' }}>Upload an Excel file containing Bank Name and Bank Code.</p>
                                <p>
                                  {/* Upload Excel File */}
                                  <Upload
                                    name="file"
                                    accept=".xlsx"
                                    showUploadList={false}
                                    customRequest={customRequest}
                                    onChange={handleFileUpload}
                                  >
                                    <Tooltip title="Click or drag to upload an Excel file">
                                      <Button
                                        icon={<UploadOutlined />}
                                        className="upload-button"
                                        size="large"
                                        style={{
                                          backgroundColor: '#1890ff',
                                          color: 'white',
                                          borderRadius: '8px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          marginTop: '16px'
                                        }}
                                      >
                                        {fileName != null
                                          ? (
                                            <>
                                              <FileExcelOutlined className="mr-2" />
                                              <span>{fileName}</span>
                                            </>
                                            )
                                          : (
                                            <>
                                              <FileExcelOutlined className="mr-2" />
                                              Click to Upload Excel File
                                            </>
                                            )}
                                      </Button>
                                    </Tooltip>
                                  </Upload>
                                </p>

                              </div>
                            )}
                          </div>
                        </Tabs.TabPane>
                      </Tabs>
                    </Modal>
                  </div>

                  {/* Pending refund reminders + System Settings */}
                  <div className="p-2.5 flex flex-col gap-2.5">
                    <Button
                      type="default"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      icon={<LinkOutlined className="text-lg" style={{ color: '#37762f' }} />}
                      style={{
                        borderColor: '#37762f',
                        color: '#1f2937',
                        fontWeight: 600,
                        background: '#f0fdf4'
                      }}
                      onClick={() => {
                        navigate('/pending-refund-reminders')
                      }}
                    >
                      Pending refund reminders
                    </Button>
                    <Button
                      onClick={showSettingsModal}
                      type="primary"
                      className="enhanced-button w-full text-sm rounded-lg flex items-center justify-start py-3.5"
                      style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #37762f 100%)',
                        border: 'none',
                        color: 'white',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
                      }}
                    >
                      <i className="fas fa-cogs mr-4 text-white text-xl"></i>
                      <span className="text-md">System Settings</span>
                    </Button>

                    {/* Modal with Tabs */}
                    <Modal
                      className="system-settings-modal"
                      title={null}
                      visible={isSettingModalVisible}
                      onCancel={handleSettingsCancel}
                      footer={null}
                      width={1280}
                      style={{ top: 24 }}
                      bodyStyle={{
                        padding: 0,
                        background: '#f8fafc',
                        borderRadius: '18px',
                        overflow: 'hidden'
                      }}
                    >
                      {/* Custom Header */}
                      <div style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                        color: 'white',
                        padding: '14px 24px',
                        borderRadius: '18px 18px 0 0',
                        marginBottom: 0,
                        boxShadow: 'inset 0 -1px 0 rgba(255, 255, 255, 0.18)'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '16px',
                          flexWrap: 'wrap'
                        }}>
                          <div>
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '5px 10px',
                              background: 'rgba(255, 255, 255, 0.14)',
                              border: '1px solid rgba(255, 255, 255, 0.22)',
                              borderRadius: '999px',
                              fontSize: '12px',
                              fontWeight: 700,
                              marginBottom: '8px'
                            }}>
                              <SafetyOutlined />
                              Secure administration
                            </div>
                            <div style={{ fontSize: '22px', fontWeight: 800, letterSpacing: '-0.02em' }}>
                              System Settings
                            </div>
                            <div style={{ fontSize: '13px', opacity: 0.88, marginTop: '4px', maxWidth: '580px', lineHeight: 1.4 }}>
                              Manage users, assign access, and review activity logs from one organized workspace.
                            </div>
                          </div>

                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            <div style={{
                              minWidth: '104px',
                              padding: '8px 12px',
                              borderRadius: '12px',
                              background: 'rgba(255, 255, 255, 0.14)',
                              border: '1px solid rgba(255, 255, 255, 0.22)'
                            }}>
                              <div style={{ fontSize: '11px', opacity: 0.78 }}>Users</div>
                              <div style={{ fontSize: '19px', fontWeight: 800 }}>{data.length}</div>
                            </div>
                            <div style={{
                              minWidth: '104px',
                              padding: '8px 12px',
                              borderRadius: '12px',
                              background: 'rgba(255, 255, 255, 0.14)',
                              border: '1px solid rgba(255, 255, 255, 0.22)'
                            }}>
                              <div style={{ fontSize: '11px', opacity: 0.78 }}>Roles</div>
                              <div style={{ fontSize: '19px', fontWeight: 800 }}>{userRolesView.length}</div>
                            </div>
                            <div style={{
                              minWidth: '104px',
                              padding: '8px 12px',
                              borderRadius: '12px',
                              background: 'rgba(255, 255, 255, 0.14)',
                              border: '1px solid rgba(255, 255, 255, 0.22)'
                            }}>
                              <div style={{ fontSize: '11px', opacity: 0.78 }}>Audit logs</div>
                              <div style={{ fontSize: '19px', fontWeight: 800 }}>{Math.max(auditLogsPagination.total, auditLogs.length)}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ padding: '24px 28px 28px 28px' }}>
                        <Tabs
                          defaultActiveKey="2"
                          size="large"
                          tabBarStyle={{
                            background: '#ffffff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '14px',
                            padding: '6px 14px 0 14px',
                            marginBottom: '24px',
                            fontWeight: '700',
                            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)'
                          }}
                        >
                        {/* Tab 2: User Management */}
                          <TabPane
                            tab={<span><TeamOutlined /> User Management</span>}
                            key="2"
                          >
                            {/* Action Buttons */}
                            <div style={{
                              background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                              padding: '20px',
                              borderRadius: '12px',
                              marginBottom: '24px',
                              border: '1px solid #e5e7eb'
                            }}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                            <Button
                                  size="large"
                                  type={activeForm === 'viewAllUsers' ? 'primary' : 'default'}
                                  icon={<TeamOutlined />}
                                  style={{
                                    background: activeForm === 'viewAllUsers' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                                    borderColor: activeForm === 'viewAllUsers' ? 'transparent' : '#d1d5db',
                                    color: activeForm === 'viewAllUsers' ? '#fff' : '#374151',
                                    fontWeight: '600',
                                    height: '44px',
                                    borderRadius: '8px',
                                    boxShadow: activeForm === 'viewAllUsers' ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none'
                                  }}
                                  onClick={() => { handleFormToggle('viewAllUsers') }}
                                >
                                  View All Users
                            </Button>

                            <Button
                                  size="large"
                                  type={activeForm === 'addRemoveUser' ? 'primary' : 'default'}
                                  icon={<UserAddOutlined />}
                                  style={{
                                    background: activeForm === 'addRemoveUser' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                                    borderColor: activeForm === 'addRemoveUser' ? 'transparent' : '#d1d5db',
                                    color: activeForm === 'addRemoveUser' ? '#fff' : '#374151',
                                    fontWeight: '600',
                                    height: '44px',
                                    borderRadius: '8px',
                                    boxShadow: activeForm === 'addRemoveUser' ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none'
                                  }}
                                  onClick={() => { handleFormToggle('addRemoveUser') }}
                                >
                                  Add/Remove Users
                            </Button>

                            <Button
                                  size="large"
                              type={activeForm === 'assignRoles' ? 'primary' : 'default'}
                                  icon={<SafetyOutlined />}
                                  style={{
                                    background: activeForm === 'assignRoles' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                                    borderColor: activeForm === 'assignRoles' ? 'transparent' : '#d1d5db',
                                    color: activeForm === 'assignRoles' ? '#fff' : '#374151',
                                    fontWeight: '600',
                                    height: '44px',
                                    borderRadius: '8px',
                                    boxShadow: activeForm === 'assignRoles' ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none'
                                  }}
                              onClick={() => { handleFormToggle('assignRoles') }}
                            >
                                  Roles & Permissions
                            </Button>

                            <Button
                                  size="large"
                              type={activeForm === 'userProfiles' ? 'primary' : 'default'}
                                  icon={<ProfileOutlined />}
                                  style={{
                                    background: activeForm === 'userProfiles' ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                                    borderColor: activeForm === 'userProfiles' ? 'transparent' : '#d1d5db',
                                    color: activeForm === 'userProfiles' ? '#fff' : '#374151',
                                    fontWeight: '600',
                                    height: '44px',
                                    borderRadius: '8px',
                                    boxShadow: activeForm === 'userProfiles' ? '0 4px 12px rgba(102, 126, 234, 0.4)' : 'none'
                                  }}
                              onClick={() => { handleFormToggle('userProfiles') }}
                            >
                              User Profiles
                            </Button>
                              </div>
                            </div>

                            {/* Content Area */}
                            <div>
                            {/* Conditional rendering based on activeForm value */}
                            {activeForm === 'addRemoveUser' && (
                              <Form
                                name="normal_login"
                                layout="vertical"
                                  style={{ marginTop: '20px' }}
                                initialValues={{ remember: true }}
                                onFinish={onUserCreate}
                              >
                                  <Card
                                    style={{
                                      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                                      borderRadius: '16px',
                                      boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                      border: '1px solid #e5e7eb'
                                    }}
                                  >
                                    <div style={{
                                      fontSize: '20px',
                                      fontWeight: '700',
                                      color: '#667eea',
                                      textAlign: 'center',
                                      marginBottom: '32px',
                                      paddingBottom: '16px',
                                      borderBottom: '3px solid #667eea'
                                    }}>
                                      <UserAddOutlined style={{ marginRight: '8px', fontSize: '24px' }} />
                                      Add New User
                                  </div>

                                    <Row gutter={24}>
                                      <Col xs={24} md={12}>
                                      <Form.Item
                                        name="nid"
                                          label={<span style={{ fontWeight: '600', color: '#374151' }}>National ID Number</span>}
                                        rules={[
                                          { required: true, message: 'Please input National ID Number' },
                                          { pattern: /^\d{16}$/, message: 'Must be 16 digits' }
                                        ]}
                                        >
                                          <Input
                                            prefix={<IdcardOutlined style={{ color: '#9ca3af' }} />}
                                            placeholder="Enter 16-digit National ID"
                                            maxLength={16}
                                            size="large"
                                            style={{
                                              borderRadius: '8px',
                                              border: '2px solid #e5e7eb',
                                              transition: 'all 0.3s'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#667eea' }}
                                            onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
                                          />
                                      </Form.Item>
                                      </Col>

                                      <Col xs={24} md={12}>
                                      <Form.Item
                                        name="full_name"
                                          label={<span style={{ fontWeight: '600', color: '#374151' }}>Full Name</span>}
                                          rules={[{ required: true, message: 'Please input Full Name' }]}
                                        >
                                          <Input
                                            prefix={<UserOutlined style={{ color: '#9ca3af' }} />}
                                            placeholder="Enter full name"
                                            size="large"
                                            style={{
                                              borderRadius: '8px',
                                              border: '2px solid #e5e7eb',
                                              transition: 'all 0.3s'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#667eea' }}
                                            onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
                                          />
                                      </Form.Item>
                                      </Col>

                                      <Col xs={24} md={12}>
                                      <Form.Item
                                        name="phone_number"
                                          label={<span style={{ fontWeight: '600', color: '#374151' }}>Phone Number</span>}
                                        rules={[{ required: true, message: 'Please input Phone Number' }]}
                                      >
                                          <Input
                                            prefix={<span style={{ color: '#9ca3af' }}>📱</span>}
                                            type="tel"
                                            placeholder="Enter phone number"
                                            size="large"
                                            style={{
                                              borderRadius: '8px',
                                              border: '2px solid #e5e7eb',
                                              transition: 'all 0.3s'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#667eea' }}
                                            onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
                                          />
                                      </Form.Item>
                                      </Col>

                                      <Col xs={24} md={12}>
                                      <Form.Item
                                        name="email"
                                          label={<span style={{ fontWeight: '600', color: '#374151' }}>Email Address</span>}
                                        rules={[
                                          { type: 'email', message: 'Please input valid Email' },
                                          { required: true, message: 'Please input Email' }
                                        ]}
                                        >
                                          <Input
                                            prefix={<span style={{ color: '#9ca3af' }}>📧</span>}
                                            placeholder="Enter email address"
                                            size="large"
                                            style={{
                                              borderRadius: '8px',
                                              border: '2px solid #e5e7eb',
                                              transition: 'all 0.3s'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#667eea' }}
                                            onBlur={(e) => { e.target.style.borderColor = '#e5e7eb' }}
                                          />
                                      </Form.Item>
                                      </Col>

                                      <Col xs={24} md={12}>
                                      <Form.Item
                                        name="role"
                                          label={<span style={{ fontWeight: '600', color: '#374151' }}>User Role</span>}
                                        rules={[{ required: false, message: 'Please select User Role' }]}
                                      >
                                        <Select
                                          placeholder="Select a role"
                                          loading={loading}
                                            size="large"
                                          allowClear
                                          showSearch
                                          optionFilterProp="children"
                                            suffixIcon={<SafetyOutlined style={{ color: '#667eea' }} />}
                                            style={{
                                              borderRadius: '8px'
                                            }}
                                        >
                                          {userRolesView.map((role) => (
                                            <Option key={role.id} value={role.name}>
                                              {role.name}
                                            </Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>

                                    <Form.Item style={{ marginTop: '24px', marginBottom: 0 }}>
                                      <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={loading}
                                        size="large"
                                        icon={<UserAddOutlined />}
                                        style={{
                                          width: '100%',
                                          height: '48px',
                                          borderRadius: '10px',
                                          background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                                          border: 'none',
                                          fontWeight: '600',
                                          fontSize: '16px',
                                          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)'
                                        }}
                                      >
                                        Add User
                                    </Button>
                                  </Form.Item>
                                </Card>
                              </Form>
                            )}

                            {activeForm === 'viewAllUsers' && (
                              <div style={{ marginTop: '20px', width: '100%' }}>
                                <Card
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                    border: '1px solid #e5e7eb',
                                    overflow: 'hidden'
                                  }}
                                >
                                  <div style={{
                                    background: 'var(--refund-theme-primary-soft)',
                                    color: '#111827',
                                    padding: '16px 20px',
                                    margin: '-24px -24px 24px -24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <TeamOutlined style={{ fontSize: '24px' }} />
                                      <span style={{ fontSize: '18px', fontWeight: '700' }}>
                                        All Users ({data.length})
                                      </span>
                                    </div>
                                  </div>

                                  <div style={{ marginBottom: '20px' }}>
                                        <Input
                                          size="large"
                                      placeholder="Search by name, email, phone, or National ID..."
                                      prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                                      style={{
                                        borderRadius: '10px',
                                        border: '2px solid #e5e7eb',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                      }}
                                          onChange={(e) => {
                                            OnUserAccountsSearch(e)
                                          }}
                                        />
                                      </div>

                                  <div style={{ overflowX: 'auto' }}>
                                      {loading
                                        ? (
                                        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                                          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                                          <div style={{ color: '#9ca3af', fontSize: '16px' }}>Loading users...</div>
                                          </div>
                                          )
                                        : (
                                          <Table
                                            columns={columnsViewMode}
                                            dataSource={data}
                                            pagination={{
                                              ...paginating,
                                              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                              showSizeChanger: true,
                                              showQuickJumper: true,
                                              hideOnSinglePage: false,
                                              pageSizeOptions: ['10', '20', '50', '100'],
                                              showLessItems: true,
                                              style: {
                                                background: '#F5F5F5',
                                                borderRadius: '8px',
                                                padding: '12px',
                                                border: '1px solid #e5e7eb',
                                                marginTop: '16px'
                                              }
                                            }}
                                            rowClassName={(record, index) =>
                                              index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                                            }
                                          />
                                          )}
                                  </div>
                                </Card>
                              </div>
                            )}

                            {activeForm === 'assignRoles' && (
                              <div className="w-full profileForm flex justify-center mt-4" style={{ width: '100%' }}>
                                <Card
                                  className="bg-white"
                                  title={
                                    // eslint-disable-next-line max-len
                                    <span style={{ backgroundColor: 'var(--refund-theme-primary-soft)', color: '#111827', padding: '5px 10px' }}>
              Assign Permission Users Roles
            </span>
                                  }
                                  style={{ marginTop: '12px' }}
                                  headStyle={{ backgroundColor: 'transparent' }}
                                >
                                  <Form
                                    form={form}
                                    layout="vertical"
                                    name="assign_role_permissions"
                                    /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
                                    onFinish={onFinish}
                                  >
                                    {/* Role Name Field */}
                                    <Form.Item
                                      name="role"
                                      label="User Role"
                                      rules={[{ required: true, message: 'Please select User Role' }]}
                                    >
                                      <Select placeholder="Select User Role" onChange={onUserTypeChange} allowClear>
                                        {userInfo?.role === 'SYSTEM ADMIN'
                                          ? (
                                            <>
                                              <Option value="SYSTEM ADMIN">SYSTEM ADMIN</Option>
                                              <Option value="THIRD PARTY">THIRD PARTY</Option>
                                              <Option value="SUPER USER">SUPER USER</Option>
                                              <Option value="SYSTEM SUPPORT">SYSTEM SUPPORT</Option>
                                              <Option value="INSTITUTION ADMIN">INSTITUTION ADMIN</Option>
                                              <Option value="INSTITUTION USER">INSTITUTION USER</Option>
                                              <Option value="MINIJUST FINANCE">MINIJUST FINANCE</Option>
                                            </>
                                            )
                                          : (
                                            <>
                                              <Option value="SYSTEM ADMIN">SYSTEM ADMIN</Option>
                                              <Option value="THIRD PARTY">THIRD PARTY</Option>
                                              <Option value="SUPER USER">SUPER USER</Option>
                                              <Option value="SYSTEM SUPPORT">SYSTEM SUPPORT</Option>
                                              <Option value="INSTITUTION ADMIN">INSTITUTION ADMIN</Option>
                                              <Option value="INSTITUTION USER">INSTITUTION USER</Option>
                                              <Option value="MINIJUST FINANCE">MINIJUST FINANCE</Option>
                                            </>
                                            )}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      label={
                                        <>
                                          Description
                                          <Tooltip title="Enter a detailed description of the item">
                                            {/* <InfoCircleOutlined style={{ marginLeft: 8 }} /> */}
                                          </Tooltip>
                                        </>
                                      }
                                      name="description"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please input the description!'
                                        }
                                      ]}
                                    >
                                      <Input.TextArea
                                        rows={4}
                                        placeholder="Please describe the item here..."
                                        style={{
                                          padding: '12px',
                                          fontSize: '16px',
                                          borderRadius: '8px',
                                          borderColor: '#d9d9d9',
                                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                                        }}
                                      />
                                    </Form.Item>
                                    <Form.Item
                                      name="permissions"
                                      label="Permissions"
                                      rules={[{ required: true, message: 'Please select at least one permission!' }]}
                                    >
                                      <Checkbox.Group style={{ width: '100%' }}>
                                        <Row>
                                          {permissions.map((permission, index) => (
                                            <Col span={8} key={index}>
                                              <Checkbox value={permission}>{permission}</Checkbox>
                                            </Col>
                                          ))}
                                        </Row>
                                      </Checkbox.Group>
                                    </Form.Item>
                                    {/* Submit Button */}
                                    <Form.Item>
                                      <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                                        Save Role & Permissions
                                      </Button>
                                    </Form.Item>
                                  </Form>
                                </Card>
                              </div>
                            )}

                            {activeForm === 'userProfiles' && (
                              <div style={{ marginTop: '20px', width: '100%' }}>
                                <Card
                                  style={{
                                    borderRadius: '16px',
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                    border: '1px solid #e5e7eb',
                                    overflow: 'hidden'
                                  }}
                                >
                                  <div style={{
                                    background: 'var(--refund-theme-primary-soft)',
                                    color: '#111827',
                                    padding: '16px 20px',
                                    margin: '-24px -24px 24px -24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                  }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <ProfileOutlined style={{ fontSize: '24px' }} />
                                      <span style={{ fontSize: '18px', fontWeight: '700' }}>
                                        Manage User Roles & Status ({data.length})
                                      </span>
                                    </div>
                                  </div>

                                  <div style={{ marginBottom: '20px' }}>
                                        <Input
                                          size="large"
                                      placeholder="Search by name, email, phone, or National ID..."
                                      prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                                      style={{
                                        borderRadius: '10px',
                                        border: '2px solid #e5e7eb',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                                      }}
                                          onChange={(e) => {
                                            OnUserAccountsSearch(e)
                                          }}
                                        />
                                      </div>

                                  <div style={{ overflowX: 'auto' }}>
                                      {loading
                                        ? (
                                        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                                          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
                                          <div style={{ color: '#9ca3af', fontSize: '16px' }}>Loading users...</div>
                                          </div>
                                          )
                                        : (
                                          <Table
                                            columns={columnsEditRolesAndUserStatus}
                                            dataSource={data}
                                          pagination={{
                                            ...paginating,
                                            showSizeChanger: true,
                                            showQuickJumper: true,
                                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
                                            pageSizeOptions: ['5', '10', '20', '50', '100'],
                                            style: { marginTop: '16px' }
                                          }}
                                          rowClassName={(record, index) =>
                                            index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                                          }
                                        />
                                          )}
                                  </div>
                                </Card>
                              </div>
                            )}
                          </div>
                        </TabPane>

                        {/* Tab 4: Audit and Logging */}
                        <TabPane
                          tab={<span><AuditOutlined /> Audit & Logging</span>}
                          key="4"
                        >
                          <div style={{
                            background: '#ffffff',
                            padding: '22px',
                            borderRadius: '18px',
                            border: '1px solid #e5e7eb',
                            boxShadow: '0 12px 30px rgba(15, 23, 42, 0.06)'
                          }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              gap: '16px',
                              flexWrap: 'wrap'
                            }}>
                              <div>
                                <div style={{
                                  color: '#064e3b',
                                  fontSize: '18px',
                                  fontWeight: 800,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px'
                                }}>
                                  <AuditOutlined />
                                  Audit & Logging
                                </div>
                                <div style={{ color: '#64748b', fontSize: '13px', marginTop: '4px' }}>
                                  Review activity records and error tracking tools from this section.
                                </div>
                              </div>

                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                                <Button
                                  size="large"
                                  type="primary"
                                  icon={<FileSearchOutlined />}
                                  style={{
                                    background: 'linear-gradient(135deg, #047857 0%, #10b981 100%)',
                                    borderColor: 'transparent',
                                    fontWeight: '700',
                                    height: '46px',
                                    borderRadius: '12px',
                                    padding: '0 20px',
                                    boxShadow: '0 10px 20px rgba(16, 185, 129, 0.26)'
                                  }}
                                  onClick={() => { alert('Activity Log Form') }}
                                >
                                  Activity Log
                                </Button>
                                <Button
                                  size="large"
                                  type="default"
                                  icon={<AuditOutlined />}
                                  style={{
                                    background: '#f8fafc',
                                    borderColor: '#cbd5e1',
                                    color: '#334155',
                                    fontWeight: '700',
                                    height: '46px',
                                    borderRadius: '12px',
                                    padding: '0 20px'
                                  }}
                                  onClick={() => { alert('Error Tracking Form') }}
                                >
                                  Error Tracking
                                </Button>
                              </div>
                            </div>
                          </div>
                        </TabPane>

                        </Tabs>
                          </div>
                    </Modal>
                  </div>

                  {/* Refund Analytics (Chart.js doughnut) */}
                  <div className="p-2.5 mt-4">
                    <Card
                      className="chart-card"
                      style={{
                        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
                      }}
                    >
                      <div style={{
                        background: 'var(--refund-theme-primary-soft)',
                        color: '#111827',
                        padding: '10px 16px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        marginBottom: '16px'
                      }}>
                        📊 Refund Analytics
                      </div>

                      {/* Refund analytics doughnut + summary */}
                      {(() => {
                        const totalRefunded = (parseInt(statsRefund?.totalRefundPayments ?? '0') + parseInt(statsBailiffRefund?.totalPayments ?? '0'))
                        const remainingToRefund = totalPaid - totalRefunded

                        // Calculate percentages
                        const refundedPercentage = totalPaid > 0 ? ((totalRefunded / totalPaid) * 100).toFixed(2) : '0.00'
                        const remainingPercentage = totalPaid > 0 ? ((remainingToRefund / totalPaid) * 100).toFixed(2) : '0.00'

                        return (
                          <>
                            <RefundAnalyticsDoughnut
                              totalPaid={totalPaid}
                              totalRefunded={totalRefunded}
                              refundedColor="#10b981"
                              remainingColor="#f59e0b"
                            />

                            {/* Summary Stats with Percentages */}
                            <div style={{ marginTop: '16px' }}>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(102, 126, 234, 0.05) 100%)',
                                borderLeft: '4px solid #667eea',
                                borderRadius: '6px',
                                marginBottom: '10px'
                              }}>
                          <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#374151' }}>Total Paid</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>Bid Security Amount</div>
                          </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#667eea' }}>
                                  {totalPaid.toLocaleString()} Rwf
                                </span>
                              </div>

                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.15) 0%, rgba(16, 185, 129, 0.05) 100%)',
                                borderLeft: '4px solid #10b981',
                                borderRadius: '6px',
                                marginBottom: '10px'
                              }}>
                          <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#374151' }}>Refunded</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>{refundedPercentage}% of Total</div>
                          </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#10b981' }}>
                                  {totalRefunded.toLocaleString()} Rwf
                                </span>
                              </div>

                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '10px 12px',
                                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.05) 100%)',
                                borderLeft: '4px solid #f59e0b',
                                borderRadius: '6px'
                              }}>
                                <div>
                                  <div style={{ fontWeight: '600', fontSize: '12px', color: '#374151' }}>Remaining to Refund</div>
                                  <div style={{ fontSize: '10px', color: '#6b7280', marginTop: '2px' }}>{remainingPercentage}% of Total</div>
                                </div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#f59e0b' }}>
                                  {remainingToRefund.toLocaleString()} Rwf
                                </span>
                              </div>
                            </div>
                          </>
                        )
                      })()}
                    </Card>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default FullDashboardView
